import { render, staticRenderFns } from "./order-insurance.vue?vue&type=template&id=099d51e0&"
import script from "./order-insurance.vue?vue&type=script&lang=js&"
export * from "./order-insurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports